import { BridgeAppraisalStatus } from '../../../../../../common/constants/BridgeAppraisalStatus';

interface RenderAppraisedArgs {
    status: BridgeAppraisalStatus;
    propertyState: string; // instead of inArizona
    appraisalAmount?: number | null;
    appraisalReceivedDate?: string | null;
}

export function renderAppraisedCell({ status, propertyState, appraisalAmount, appraisalReceivedDate }: RenderAppraisedArgs) {
    const inArizona = propertyState?.toUpperCase() === 'AZ';

    const fmtAmount = (amt?: number | null) => (amt != null ? `$${amt.toLocaleString()}` : '');

    const fmtDate = (iso?: string | null) => {
        if (!iso) return '';
        const d = new Date(iso);
        return `${d.getMonth() + 1}/${d.getFullYear().toString().slice(-2)}`;
    };

    let text = '';
    let bg: string | undefined;

    switch (status) {
        case BridgeAppraisalStatus.NothingReceived:
            text = '-';
            break;

        case BridgeAppraisalStatus.PaymentReceived:
            text = inArizona ? 'na$' : '$';
            break;

        case BridgeAppraisalStatus.SurveyReceived:
            text = 'Survey';
            break;

        case BridgeAppraisalStatus.PaymentAndSurveyReceived:
            text = inArizona ? 'na$ + Survey' : '$ + Survey';
            break;

        case BridgeAppraisalStatus.ReadyForAppraisal:
            text = 'Ready';
            bg = '#d4f7d4';
            break;

        case BridgeAppraisalStatus.AppraisalOrdered:
            bg = '#d9ecff';
            text = appraisalReceivedDate ? `Recvd ${fmtDate(appraisalReceivedDate)}` : 'Ordered';
            break;

        case BridgeAppraisalStatus.Appraised:
        case BridgeAppraisalStatus.ApprovedAndWaitingToClose:
        case BridgeAppraisalStatus.Closed:
            bg = '#bcd6ff';
            text = fmtAmount(appraisalAmount);
            break;

        default:
            text = '';
    }

    return (
        <div
            style={{
                backgroundColor: bg ?? 'transparent',
                padding: '2px 2px',
            }}
        >
            {text}
        </div>
    );
}
